import { mount, StartClient } from "@solidjs/start/client";
import { initDebugOverlay } from "./lib/debug-overlay";
import { loadDict } from "./context/locale";
import { localeFromPath, LANGUAGES } from "@/locales/registry";

window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  const last = Number(sessionStorage.getItem("preloadErrorReload") || 0);
  if (Date.now() - last > 10000) {
    sessionStorage.setItem("preloadErrorReload", String(Date.now()));
    window.location.reload();
  }
});

initDebugOverlay();

const code = localeFromPath(window.location.pathname);
const app = document.getElementById("app");

if (!app) {
  throw new Error("Missing #app mount element");
}

Promise.all([loadDict("en"), loadDict(code)]).finally(() => {
  mount(() => <StartClient />, app);
  LANGUAGES.forEach((l) => loadDict(l.code));
});
